import React, { createContext, FC } from "react";

import useLocalStorage from "@rehooks/local-storage";

export const ENV_KEY = "environment";

export const EnvironmentContext = createContext<{
  env: null | string;
  setEnv: (env: string) => void;
  unsetEnv: () => void;
}>({
  env: null,
  setEnv: () => {},
  unsetEnv: () => {},
});

export const EnvironmentContextProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const value = Object.assign({}, useEnvironmentHandler());
  return (
    <EnvironmentContext.Provider value={value}>
      {children}
    </EnvironmentContext.Provider>
  );
};

const useEnvironmentHandler = () => {
  const [env, setEnvironment, unsetEnvironment] = useLocalStorage<string>(
    ENV_KEY
  );

  return {
    env,

    setEnv(env: string) {
      setEnvironment(env);
    },

    unsetEnv() {
      unsetEnvironment();
    },
  };
};
